module.exports = __webpack_public_path__ + "static/media/Partly_Quiet.4d68d16e.gif";